// import external dependencies

import "jquery";

// Import everything from autoload
import "./autoload/_foundation.js";
import headerToggle from "./modules/ac-header-menu-toggle";
import acfMap from "./modules/map";
import jobsAccordion from "./modules/jobs-toggle";
import contactForm from "./modules/contact-form";
import jobsFrame from "./modules/jobs-frame";
import burgerBtn from "./modules/burger-btn";
import headerFix from "./modules/header-fix";

jQuery(document).ready(() => {
	jobsAccordion();

	if ($(".nav-primary__toggle-btn").length > 0) headerToggle();

	if ($(".acf-map").length > 0) acfMap();

	if ($(".ac-contact").length > 0) contactForm();

	if ($(".ac-jobs").length > 0) jobsFrame();

	if ($("header .header___mobile").length > 0) burgerBtn();

	if ($("header .nav-primary").length > 0) headerFix();

});



// WEBPACK FOOTER //
// ./scripts/main.js